/* Moteknest — "הכיסא שבתיק" product page behaviour.
   Owns: gallery, colour picker, offer (1 / bundle) selector, price display, AJAX add-to-cart,
   sticky bar, final CTA, demo-video autoplay. Uses the standard /cart/add.js endpoint so
   Shopify's standard customer events (product_added_to_cart → Meta AddToCart via the
   Facebook & Instagram channel) fire without any extra pixel code. */
(function () {
  'use strict';

  function formatMoney(cents, format) {
    var value = (cents / 100);
    var fixed2 = value.toFixed(2);
    var noDec = Math.round(value).toString();
    var f = format || '₪{{amount}}';
    return f
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDec)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, fixed2.replace('.', ','))
      .replace(/\{\{\s*amount\s*\}\}/g, fixed2)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, noDec);
  }

  function initHero(root) {
    if (!root || root.dataset.mnhInit === '1') return;
    root.dataset.mnhInit = '1';

    var dataEl = root.querySelector('[data-mnh-data]');
    if (!dataEl) return;
    var data = JSON.parse(dataEl.textContent);
    var form = root.querySelector('form[data-mnh-form]');
    if (!form) return;
    var idInput = form.querySelector('input[name="id"]');
    var qtyInput = form.querySelector('input[name="quantity"]');
    var atcButtons = Array.prototype.slice.call(document.querySelectorAll('[data-mnh-atc]'));
    var error = root.querySelector('[data-mnh-error]');
    var priceNow = document.querySelectorAll('[data-mnh-price-now]');
    var priceWas = document.querySelectorAll('[data-mnh-price-was]');
    var priceNote = document.querySelectorAll('[data-mnh-price-note]');
    var stock = root.querySelector('[data-mnh-stock]');
    var colorButtons = Array.prototype.slice.call(root.querySelectorAll('[data-mnh-variant]'));
    var offerRadios = Array.prototype.slice.call(root.querySelectorAll('input[name="mnh-offer"]'));
    var sticky = document.querySelector('[data-mnh-sticky]');
    var variantTitles = document.querySelectorAll('[data-mnh-variant-title]');
    var busy = false;

    function currentVariant() {
      var id = idInput.value;
      for (var i = 0; i < data.variants.length; i++) {
        if (String(data.variants[i].id) === String(id)) return data.variants[i];
      }
      return data.variants[0];
    }
    function currentQty() {
      var checked = offerRadios.filter(function (r) { return r.checked; })[0];
      var q = checked ? parseInt(checked.dataset.qty, 10) : parseInt(qtyInput.value, 10);
      return Math.max(1, q || 1);
    }
    // Bundle price for `qty` units of `unit` cents, or 0 when no bundle applies.
    // Mirrors the automatic discount that really applies in the cart (fixed total or percent off).
    function bundlePrice(unit, qty) {
      var b = data.bundle;
      if (!b || !b.enabled || qty !== b.qty) return 0;
      var total = unit * qty;
      var price = b.fixed > 0 ? b.fixed : (b.percent > 0 ? Math.round(total * (100 - b.percent) / 100) : 0);
      return (price > 0 && price < total) ? price : 0;
    }

    function render() {
      var v = currentVariant();
      var qty = currentQty();
      qtyInput.value = String(qty);
      var unit = v.price;
      var now = unit * qty;
      var was = 0;
      var note = '';
      var bp = bundlePrice(unit, qty);
      if (bp > 0) {
        was = now;
        now = bp;
        note = data.strings.bundleNote || '';
      } else if (v.compare_at_price && v.compare_at_price > unit) {
        was = v.compare_at_price * qty;
      }
      priceNow.forEach(function (el) { el.textContent = formatMoney(now, data.moneyFormat); });
      priceWas.forEach(function (el) {
        if (was > now) { el.textContent = formatMoney(was, data.moneyFormat); el.hidden = false; }
        else { el.textContent = ''; el.hidden = true; }
      });
      priceNote.forEach(function (el) { el.textContent = note; el.hidden = !note; });

      // per-offer prices in the offer cards
      offerRadios.forEach(function (r) {
        var q = parseInt(r.dataset.qty, 10) || 1;
        var card = r.closest('.mnh-offer');
        if (!card) return;
        var p = card.querySelector('[data-mnh-offer-price]');
        var s = card.querySelector('[data-mnh-offer-was]');
        var b = card.querySelector('[data-mnh-offer-badge]');
        var total = unit * q;
        var obp = bundlePrice(unit, q);
        if (obp > 0) {
          if (p) p.textContent = formatMoney(obp, data.moneyFormat);
          if (s) { s.textContent = formatMoney(total, data.moneyFormat); s.hidden = false; }
          if (b) { b.textContent = (data.strings.saveLabel || '').replace('%s', formatMoney(total - obp, data.moneyFormat)); b.hidden = false; }
        } else {
          if (p) p.textContent = formatMoney(total, data.moneyFormat);
          if (s) { s.textContent = ''; s.hidden = true; }
          if (b) { b.hidden = true; }
        }
      });

      colorButtons.forEach(function (b) {
        var on = String(b.dataset.mnhVariant) === String(v.id);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      var label = root.querySelector('[data-mnh-color-label]');
      if (label) label.textContent = v.title;
      variantTitles.forEach(function (el) { el.textContent = v.title; });

      var available = !!v.available;
      atcButtons.forEach(function (btn) {
        btn.disabled = busy || !available;
        var txt = busy ? data.strings.loading : (available ? (btn.dataset.cta || data.strings.cta) : data.strings.soldOut);
        var span = btn.querySelector('span') || btn;
        span.textContent = txt;
      });
      if (stock) stock.hidden = !available;
      root.dispatchEvent(new CustomEvent('mnh:variant', { bubbles: true, detail: { variant: v, quantity: qty } }));
    }

    function scrollGalleryToVariant(v) {
      if (!v || !v.featured_media_id) return;
      var slide = root.querySelector('.mnh-gal__slide[data-media-id="' + v.featured_media_id + '"]');
      if (slide && root.mnhGallery) root.mnhGallery.goTo(slide);
    }

    colorButtons.forEach(function (b) {
      b.addEventListener('click', function () {
        idInput.value = b.dataset.mnhVariant;
        render();
        scrollGalleryToVariant(currentVariant());
      });
    });
    offerRadios.forEach(function (r) { r.addEventListener('change', render); });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (busy) return;
      var v = currentVariant();
      if (!v.available) return;
      busy = true;
      if (error) error.hidden = true;
      render();
      var fd = new FormData(form);
      fd.set('id', String(v.id));
      fd.set('quantity', String(currentQty()));
      // Bundle apps (e.g. Kaching Bundles) inject their own hidden fields into every product form.
      // Their automatic discount applies by quantity anyway, so keep the line item clean.
      var drop = [];
      fd.forEach(function (val, k) { if (/^properties\[__/.test(k) || k === 'mnh-offer') drop.push(k); });
      drop.forEach(function (k) { fd.delete(k); });
      fetch(data.addUrl, { method: 'POST', body: fd, headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin' })
        .then(function (res) { return res.json().then(function (json) { return { ok: res.ok, json: json }; }); })
        .then(function (r) {
          if (!r.ok) throw new Error((r.json && (r.json.description || r.json.message)) || 'cart-add-failed');
          document.dispatchEvent(new CustomEvent('mn:add_to_cart', { detail: { variantId: v.id, quantity: currentQty(), price: v.price, currency: data.currency } }));
          window.location.assign(data.cartUrl);
        })
        .catch(function (err) {
          busy = false;
          render();
          if (error) { error.textContent = data.strings.error; error.hidden = false; error.scrollIntoView({ block: 'nearest' }); }
          if (window.console) console.warn('[mnh] add to cart failed', err);
        });
    });

    // Buttons outside the form (sticky bar, final CTA) submit the same form.
    atcButtons.forEach(function (btn) {
      if (btn.form === form || form.contains(btn)) return;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (typeof form.requestSubmit === 'function') form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true }));
      });
    });

    // Sticky bar (mobile) — shown once the main button scrolled above the viewport, hidden near the final CTA.
    var mainBtn = form.querySelector('[data-mnh-atc]');
    var finalEl = document.querySelector('[data-mnh-final]');
    if (sticky && mainBtn) {
      var on = false, ticking = false;
      var setOn = function (v) {
        if (v === on) return; on = v;
        sticky.classList.toggle('is-on', on);
        sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
        document.body.classList.toggle('mnh-pad', on);
      };
      var check = function () {
        ticking = false;
        var r = mainBtn.getBoundingClientRect();
        var finalVisible = false;
        if (finalEl) { var fr = finalEl.getBoundingClientRect(); finalVisible = fr.top < window.innerHeight && fr.bottom > 0; }
        setOn(r.bottom < 0 && !finalVisible && currentVariant().available);
      };
      var onScroll = function () { if (!ticking) { ticking = true; window.requestAnimationFrame(check); } };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      check();
    }

    render();
  }

  function initGallery(root) {
    var gal = root.querySelector('[data-mnh-gallery]');
    if (!gal || gal.dataset.mnhInit === '1') return;
    gal.dataset.mnhInit = '1';
    var track = gal.querySelector('.mnh-gal__track');
    var slides = Array.prototype.slice.call(gal.querySelectorAll('.mnh-gal__slide'));
    var dots = Array.prototype.slice.call(gal.querySelectorAll('.mnh-gal__dots button'));
    var thumbs = Array.prototype.slice.call(gal.querySelectorAll('.mnh-gal__thumbs button'));
    if (!track || slides.length < 2) return;
    var current = 0;
    function setCurrent(i) {
      current = i;
      dots.forEach(function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      slides.forEach(function (s, k) {
        var v = s.querySelector('video');
        if (!v) return;
        if (k === i) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else { v.pause(); }
      });
    }
    function goTo(target) {
      var i = typeof target === 'number' ? target : slides.indexOf(target);
      if (i < 0) return;
      track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
      setCurrent(i);
    }
    var t;
    track.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        var w = slides[0].getBoundingClientRect().width || 1;
        var i = Math.round(track.scrollLeft / (w + 8));
        i = Math.max(0, Math.min(slides.length - 1, i));
        if (i !== current) setCurrent(i);
      }, 60);
    }, { passive: true });
    dots.forEach(function (d, k) { d.addEventListener('click', function () { goTo(k); }); });
    thumbs.forEach(function (b, k) { b.addEventListener('click', function () { goTo(k); }); });
    root.mnhGallery = { goTo: goTo };
    setCurrent(0);
  }

  function initVideos(scope) {
    var videos = Array.prototype.slice.call(scope.querySelectorAll('.mnh video')).filter(function (v) {
      return !v.closest('.mnh-gal__slide') && v.dataset.mnhVideoInit !== '1';
    });
    if (!videos.length) return;
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var saveData = navigator.connection && navigator.connection.saveData;
    videos.forEach(function (v) { v.dataset.mnhVideoInit = '1'; v.muted = true; v.loop = true; v.setAttribute('playsinline', ''); v.removeAttribute('controls'); });
    if (!('IntersectionObserver' in window) || reduced || saveData) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting && en.intersectionRatio >= 0.4) { v.muted = true; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else if (!v.paused) v.pause();
      });
    }, { threshold: [0, 0.4, 1] });
    videos.forEach(function (v) { io.observe(v); });
  }

  function boot(scope) {
    scope = scope || document;
    Array.prototype.slice.call(scope.querySelectorAll('[data-mnh-hero]')).forEach(function (root) { initGallery(root); initHero(root); });
    initVideos(scope);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); });
  else boot(document);
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
